import React from 'react';
import * as Yup from "yup";
import { Field, Formik } from "formik";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField";

const validationSchema = Yup.object({
    role: Yup.string().required("Role is a required")
  });

  const initialValues = {
    role: "",
    status: "",
    name: "",
  };

  const roleOptions = [
    { id: 1, label: "Role1" },
    { id: 2, label: "Role2" },
    { id: 3, label: "Role3" },
  ];

  const statusOptions = [
    { id: 1, label: "Active" },
    { id: 2, label: "Inactive" },
  ];

const SearchUsers = ({ onSearch }) => {
    const handleSubmit = (val, action) => {
      const { setSubmitting } = action;
        onSearch(val);
        setSubmitting(false)
    };

    const handleReset = (props) => {
        // console.log(resetFrom);
        console.log(props)
        const { resetFrom } = props;
        resetFrom()
    }

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize={true}
      children={(props) => {
        const { isSubmitting, handleSubmit, re } = props;
        return (
          <div>
            <h5 className="f-15 text-primary font-weight-700">Search Users</h5>
            <Row>
                <Col md={2} sm={3} xs={6}>
                <FormGroup>
                  <Label for="name">Name</Label>
                  <Field
                    id="name"
                    name="name"
                    type="text"
                    autoComplete="off"
                    component={FormikInputField}
                  />
                </FormGroup>
                </Col>
              <Col md={2} sm={3} xs={6}>
                <FormGroup>
                  <Label for="role">Role</Label>
                  <Field
                    name="role"
                    type="text"
                    className="required"
                    component={FormikSelectField}
                    options={roleOptions}
                    defaultoption="--Select--"
                    keys={{
                      id: "id",
                      label: "label",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={2} sm={3} xs={6}>
                <FormGroup>
                  <Label for="status">Status</Label>
                  <Field
                    name="status"
                    type="text"
                    className="required"
                    component={FormikSelectField}
                    options={statusOptions}
                    defaultoption="--Select--"
                    keys={{
                      id: "id",
                      label: "label",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="auto" className="pt-4 mt-1">
                    <Button
                      disabled={isSubmitting}
                      onClick={handleSubmit}
                      color="primary"
                      className="ms-3"
                    >
                      Search
                    </Button>
                    <Button color="primary" onClick={() => handleReset(props)}>
                      Reset
                    </Button>
                  </Col>
            </Row>
          </div>
        );
      }}
    ></Formik>
  )
}

export default SearchUsers;